import { render, staticRenderFns } from "./Reflections.vue?vue&type=template&id=7ad6a7f0&scoped=true&"
import script from "./Reflections.vue?vue&type=script&lang=js&"
export * from "./Reflections.vue?vue&type=script&lang=js&"
import style0 from "./Reflections.vue?vue&type=style&index=0&id=7ad6a7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad6a7f0",
  null
  
)

export default component.exports